import { PrintCustomerRequestComponent } from './components/print-customer-request/print-customer-request.component';
import { PrintInformMultiFileComponent } from './components/print-inform-multi-file/print-inform-multi-file.component';
import { PrintRequestGeneralComponent } from './components/print-request-general/print-request-general.component';
import { RequestGeneralComponent } from './components/request-general/request-general.component';
import { PrintReportInvoiceCancelComponent } from './components/print-report-invoice-cancel/print-report-invoice-cancel.component';
import { PrintReportBillCancelComponent } from './components/print-report-bill-cancel/print-report-bill-cancel.component';
import { ReportFeeCancelComponent } from './components/report-fee-cancel/report-fee-cancel.component';
import { ReportBillCancelComponent } from './components/report-bill-cancel/report-bill-cancel.component';
import { ReportInvoiceCancelComponent } from './components/report-invoice-cancel/report-invoice-cancel.component';
import { InvoiceNgxTableComponent } from './components/invoice-ngx-table/invoice-ngx-table.component';
import { PrintReportLogsComponent } from './components/print-report-logs/print-report-logs.component';
import { PrintReportBillComponent } from './components/print-report-bill/print-report-bill.component';
import { PrintReportInvoiceComponent } from './components/print-report-invoice/print-report-invoice.component';
import { PrintReportInformComponent } from './components/print-report-inform/print-report-inform.component';
import { ImportInvoiceComponent } from './components/import-invoice/import-invoice.component';
import { ReporLogsComponent } from './components/repor-logs/repor-logs.component';
import { ReportBillComponent } from './components/report-bill/report-bill.component';
import { ReportInvoiceComponent } from './components/report-invoice/report-invoice.component';
import { ReportInformComponent } from './components/report-inform/report-inform.component';
import { PrintInformComponent } from './components/print-inform/print-inform.component';
import { PrintBillComponent } from './components/print-bill/print-bill.component';
import { UserZoneComponent } from './components/user-zone/user-zone.component';
import { CustomerRequestComponent } from './components/customer-request/customer-request.component';
import { MapsGoogleComponent } from './components/maps-google/maps-google.component';
import { MapsVectorComponent } from './components/maps-vector/maps-vector.component';
import { ChartComponent } from './components/chart/chart.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/login/login.component';
import { CustomerComponent } from './components/customer/customer.component';
import { P404Component } from './components/error/404.component';
import { FeeComponent } from './components/fee/fee.component';
import { fee_types_lange } from './language/fee_type';
import { StayTypeComponent } from './components/stay-type/stay-type.component';
import { FeeTypeComponent } from './components/fee-type/fee-type.component';
import { PaymentTypeComponent } from './components/payment-type/payment-type.component';
import { PaybillComponent } from './components/paybill/paybill.component';
import { UserPositionComponent } from './components/user-position/user-position.component';
import { AuthGuard } from './auth.service';
import { TimeoutComponent } from './components/timeout/timeout.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ClearPaymentComponent } from './components/clear-payment/clear-payment.component';
import { PrefixComponent } from './components/prefix/prefix.component';
import { PlaceMapComponent } from './components/place-map/place-map.component';
import { InvoiceHistory } from './components/invoice-history/invoice-history';
import { LogsComponent } from './components/logs/logs.component';
import { MarketPlaceComponent } from './components/market-place/market-place.component';
import { TestComponent } from './components/test/test.component';
import { RequestComponent } from './components/request/request.component';
import { SubjectComponent } from './components/subject/subject.component';
import { PrintInvoiceComponent } from './components/print-invoice/print-invoice.component';
import { ImportBillComponent } from './components/import-bill/import-bill.component';
import { PrintInvoiceMultiFileComponent } from './components/print-invoice-multi-file/print-invoice-multi-file.component';
// import { HeaderComponent } from './shared/header/header.component';
//print size 3X4
import {PrintBillComponent_3X4} from './components/print-bill_3X4/print-bill-3x4.component';
import {PrintInformComponent_3X4} from './components/print-inform_3X4/print-inform-3x4.component';
import {PrintInvoiceComponent_3X4} from './components/print-invoice_3X4/print-invoice-3x4.component';


import { PrintReportInformComponentExcel } from './components/print-report-inform-excel/print-report-inform-excel.component';
import { PrintReportInvoiceComponentExcel } from './components/print-report-invoice-excel/print-report-invoice-excel.component';
import { PrintReportInvoiceCancelComponentExcel } from './components/print-report-invoice-cancel-excel/print-report-invoice-cancel-excel.component';
import { PrintReportBillComponentExcel } from './components/print-report-bill-excel/print-report-bill-excel.component';
import { PrintReportBillCancelComponentExcel } from './components/print-report-bill-cancel-excel/print-report-bill-cancel-excel.component';
// import {ManageMarketComponent} from './components/manage-market/managemarket.component';





export const routes: Routes = [
  // { path:'test',
  //   component:HeaderComponent
  // },
    {
      path:"",
      redirectTo:"/login",
      pathMatch:'full'
    },{
      path:'',
      canActivate:[AuthGuard],
      canActivateChild:[AuthGuard],
      component:LayoutComponent,
      data:{
        title:{
          TH:"หน้าแรก",
          EN:"Home"
        }
      },
      children:[
        {
          path:"customer_request",
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          component:CustomerRequestComponent,
          data:{
            title:{TH:"คำร้องเพิ่มข้อมูล",EN:"Customer Request"}
          }
        },
        {
          path:"customer",
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          component:CustomerComponent,
          data:{
            title:{TH:"ข้อมูลลูกค้า",EN:"Customer Data"}
          }
        }, {
          path:"prefix",
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          component:PrefixComponent,
          data:{
            title:{
              TH:"ข้อมูลคำนำหน้า",
              EN:"Name's Prefix Data"
            }
          }
        }, {
          path:"maps_vector",
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          component:MapsVectorComponent,
          data:{
            title:{
              TH:"แผนที่แสดงข้อมูลที่อยู่",
              EN:"Map Showing Customer Place"
            }
          }
        },{
          path:"dashboard",
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          component:DashboardComponent
        },{
          path:"place_type",
          component:StayTypeComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ข้อมูลชนิดที่อยู่",EN:"Place Type Data"}
          }
        },
        {
          path:"fee",
          component:FeeComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ข้อมูลค่าธรรมเนียม",EN:"Fee Data"}
          }
        },{
          path:"fee_type",
          component:FeeTypeComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ข้อมูลชนิดค่าธรรมเนียม",EN:"Fee Type Data"}
          }
        },{
          path:"payment_type",
          component:PaymentTypeComponent,
          data:{
            title:{TH:"ข้อมูลประเภทการชำระ",EN:"Payment Type Data"}
          }
        },{
          path:"market_place",
          component:MarketPlaceComponent,
          data:{
            title:{TH:"ข้อมูลแผนผังของตลาด",EN:"Market Map Data"}
          }
        },{
          path:"paybill",
          component:PaybillComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ชำระค่าธรรมเนียม",EN:"Payment Fee"}
          }
        }
        ,{
          path:"clear_payment",
          component:ClearPaymentComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"เคลียร์ยอดเงินสด",EN:"Clear Payment"}
          }
        }
        ,{
          path:"user_position",
          component:UserPositionComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ตำแหน่งของพนักงาน",EN:"User Position"}
          }
        },
        {
          path:"user_zone",
          component:UserZoneComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"โซนของพนักงาน",EN:"Employee Zone"}
          }
        }
        ,{
          path:"request",
          component:RequestComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ข้อมูลการร้องเรียน",EN:"Requesting Data"}
          },
        },{
          path:"subject",
          component:SubjectComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ข้อมูลหัวข้อการร้องเรียน",EN:"Subject Data"}
          }
        },{
          path:"logs",
          component:LogsComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ประวัติการเข้าถึงข้อมูล",EN:"Logs"}
          }
        },
        {
          path:"chart",
          component:ChartComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"กราฟข้อมูลสรุป",EN:"Chart"}
          }
        }
        ,
        {
          path:"report_inform",
          component:ReportInformComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"รายงานใบทวงหนี้",EN:"Report of Inform"}
          }
        },
        {
          path:"report_invoice",
          component:ReportInvoiceComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"รายงานใบแจ้งหนี้",EN:"Report of Invoice"}
          }
        },
        {
          path:"report_invoice_cancel",
          component:ReportInvoiceCancelComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"รายงานการยกเลิกใบแจ้งหนี้",EN:"Report of Invoice (Cancel)"}
          }
        },
        {
          path:"report_bill",
          component:ReportBillComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"รายงานใบเสร็จรับเงิน",EN:"Report of Bill"}
          }
        },
        {
          path:"report_bill_cancel",
          component:ReportBillCancelComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"รายงานการยกเลิกใบเสร็จรับเงิน",EN:"Report of Bill (Cancel)"}
          }
        },
        {
          path:"report_fee_cancel",
          component:ReportFeeCancelComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"รายงานการยกเลิกค่าธรรมเนียม",EN:"Report of Fee (Cancel)"}
          }
        },
        {
          path:"report_logs",
          component:LogsComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"รายงานประวัติการใช้งานระบบ",EN:"Report of Logs"}
          }
        },
        {
          path:"import_bill",
          component:ImportBillComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"นำเข้าข้อมูลใบเสร็จรับเงิน",EN:"Import Bill"}
          }
        },
        {
          path:"import_invoice",
          component:ImportInvoiceComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"นำเข้าข้อมูลใบแจ้งหนี้",EN:"Import Invoice"}
          }
        },
      
        {
          path:"request_general",
          component:RequestGeneralComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"คำร้องทั่วไป",EN:"Request General"}
          }
        },
        {
          path:"invoice",
          component:InvoiceComponent,
          canActivate:[AuthGuard],
          canActivateChild:[AuthGuard],
          data:{
            title:{TH:"ใบแจ้งหนี้",EN:"Invoice"}
          }
        },
        // {
        //   path:"manage_market",
        //   component:ManageMarketComponent,
        //   canActivate:[AuthGuard],
        //   canActivateChild:[AuthGuard],
        //   data:{
        //     title:{TH:"ข้อมูลตลาด",EN:"Market Data"}
        //   }
        // },
      ]
    },{
      path:"timeout",
      component:TimeoutComponent
    },{
      path:"login",
      component:LoginComponent
    },
    {
      path:"print-bill",
      component:PrintBillComponent
    },
    {
      path:"print-invoice",
      component:PrintInvoiceComponent
    },
    {
      path:"print-inform",
      component:PrintInformComponent
    },
    {
      path:"print-report-inform",
      component:PrintReportInformComponent
    },
    {
      path:"print-report-invoice",
      component:PrintReportInvoiceComponent
    },
    {
      path:"print-report-invoice-cancel",
      component:PrintReportInvoiceCancelComponent
    },
    {
      path:"print-report-bill",
      component:PrintReportBillComponent
    },
    {
      path:"print-report-bill-cancel",
      component:PrintReportBillCancelComponent
    },
    {
      path:"print-report-logs",
      component:PrintReportLogsComponent
    },
    {
      path:"print-request-general",
      component:PrintRequestGeneralComponent
    },
    {
      path:"print-customer-request",
      component:PrintCustomerRequestComponent
    },
    {
      path:"print-invoice-multi-file",
      component:PrintInvoiceMultiFileComponent
    },
    {
      path:"print-inform-multi-file",
      component:PrintInformMultiFileComponent
    },
    {
      path:"print-bill-3x4",
      component:PrintBillComponent_3X4
    },
    {
      path:"print-report-inform-excel",
      component:PrintReportInformComponentExcel
    },
    {
      path:"print-report-invoice-excel",
      component:PrintReportInvoiceComponentExcel
    },
    {
      path:"print-report-invoice-cancel-excel",
      component:PrintReportInvoiceCancelComponentExcel
    },
    {
      path:"print-report-bill-excel",
      component:PrintReportBillComponentExcel
    },
    {
      path:"print-report-bill-cancel-excel",
      component:PrintReportBillCancelComponentExcel
    },
    {
      path:"print-inform-3x4",
      component:PrintInformComponent_3X4
    },
    {
      path:"print-invoice-3x4",
      component:PrintInvoiceComponent_3X4
    },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
